import { MetadataType as l } from "../../constants/metadata.js";
import d from "./useInjectConstellation.js";
import p from "./useInjectDictionary.js";
import u from "./useInjectJson.js";
import y from "./useInjectPath.js";
import { useCallback as e } from "react";
const w = () => {
  const { injectData: n } = u(), {
    data: o,
    fetchData: c,
    injectData: i
  } = p(), { fetchData: r, injectData: s } = y(), { data: f, fetchData: D } = d(), m = e(async () => {
    await Promise.all([c(), D(), r()]);
  }, [D, c, r]), h = e(
    (t) => {
      const a = i(t);
      return s(a || {}, {
        [l.Constellation]: f(),
        [l.Dictionary]: o()
      });
    },
    [f, o, i, s]
  ), j = e(
    async (t, a) => n(t, a),
    [n]
  );
  return {
    fetchMetadata: m,
    injectMetadataLegacyMode: h,
    injectMetadata: j
  };
};
export {
  w as default
};
//# sourceMappingURL=useInjectMetadata.js.map
